import { render } from "./PpcSignedUrlView.vue?vue&type=template&id=231fffdc"
import script from "./PpcSignedUrlView.vue?vue&type=script&lang=js"
export * from "./PpcSignedUrlView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__